import * as Sentry from "@sentry/vue";
import useAuthenticationStore from "@/shared/stores/authentication.store.ts";

// Global list of prioritized users for increased sampling
const prioritizedUsers = ["info@patatclub.be", "frederic@marcando.be"];

function isDesktop() {
    return !/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
}

export function initSentry({release, environment, dsn, app, router}: {
    release: string;
    environment: string;
    dsn: string;
    app: any;
    router: any
}, autoInject: boolean) {
    Sentry.init({
        app,
        dsn,
        environment: environment,
        release,
        integrations: [
            Sentry.browserTracingIntegration({router}),
            // Include feedback integration only if the device is a desktop
            ...(isDesktop()
                    ? [
                        // @ts-ignore
                        Sentry.feedbackIntegration({
                            autoInject: autoInject,
                            colorScheme: "system",
                            isEmailRequired: true,
                        })
                    ]
                    : []
            ),
        ],

        tracePropagationTargets: [/^\/ mapi/],
        // Performance Monitoring
        tracesSampler: ({name, attributes, parentSampled}) => {
            try {
                const authStore = useAuthenticationStore();
                const username = authStore?.account?.username;

                // If the user is prioritized, increase the sample rate to 100%
                if (prioritizedUsers.includes(username)) {
                    return 1.0; // Full performance trace sampling for prioritized users
                }
            } catch (e) {
                console.error("Error in tracesSampler:", e);
            }

            return 0.5; // Default sample rate for performance monitoring
        },
        // Add this to filter out warnings
        beforeSend(event) {
            if (event.level === 'warning') {
                return null;
            }
            return event;
        },
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

